define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaRegulationMethodDomain = void 0;
    class WaRegulationMethodDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaRegulationMethodDomain.MinimumWaterHeight, value: "Minimum Water Height" },
                    { key: WaRegulationMethodDomain.MinimumVolume, value: "Minimum Volume" },
                    { key: WaRegulationMethodDomain.PlacementOfOfftake, value: "Placement of Offtake" },
                    { key: WaRegulationMethodDomain.SizeOfOfftakeSetup, value: "Size of Offtake Setup" },
                    { key: WaRegulationMethodDomain.BothPlacementAndSizeOfOfftake, value: "Both Placement and Size of Offtake" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaRegulationMethodDomain.MinimumWaterHeight] = 0;
                this.KeyIndex[WaRegulationMethodDomain.MinimumVolume] = 1;
                this.KeyIndex[WaRegulationMethodDomain.PlacementOfOfftake] = 2;
                this.KeyIndex[WaRegulationMethodDomain.SizeOfOfftakeSetup] = 3;
                this.KeyIndex[WaRegulationMethodDomain.BothPlacementAndSizeOfOfftake] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Minimum Water Height"] = 0;
                this.ValueIndex["Minimum Volume"] = 1;
                this.ValueIndex["Placement of Offtake"] = 2;
                this.ValueIndex["Size of Offtake Setup"] = 3;
                this.ValueIndex["Both Placement and Size of Offtake"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaRegulationMethodDomain = WaRegulationMethodDomain;
    Object.defineProperty(WaRegulationMethodDomain, "MinimumWaterHeight", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaRegulationMethodDomain, "MinimumVolume", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaRegulationMethodDomain, "PlacementOfOfftake", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaRegulationMethodDomain, "SizeOfOfftakeSetup", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaRegulationMethodDomain, "BothPlacementAndSizeOfOfftake", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(WaRegulationMethodDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
